export const HORIZONTAL_SCALE_NS = 'components/HorizontalScale';

export const i18n = {
  en: {
    instant: 'Instant',
    average: 'Average',
    na: 'Not applicable',
    emptyValuePlaceholder: '--',
  },
};
